import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TreeFormFeatures from './form-tabs/TreeFormFeatures';
import { useProjectMapContext } from './../../../hooks/useProjectMapContext';
import useItemsService from './../../../hooks/useItemsService';
import { HtmlElement } from './../../../../helpers/HtmlElements/HtmlElements';
import { debug } from './../../../../../utils';
import API from './../../../../../api';
import './../../../../../css/nav-tabs.css'
// import './css/masonry.scss';
import ResponsiveNavTabs from './../../../../helpers/ResponsiveNavTabs/ResponsiveNavTabs';
import LayerSelector from 'components/projects/helpers/LayerSelector';
const TreesGroupForm = ({ item = null }) => {
  const {
    userCan,
    setItemSelected,
  } = useProjectMapContext();
  const {
    save_item, update_item,
  } = useItemsService();
  const project = useSelector(state => state.project);
  const [activeTab, setActiveTab] = useState(0);
  const [itemCopy, setItemCopy] = useState({ initialized: false, meta: {} });
  const [layersOptions, setLayersOptions] = useState([]);
  useEffect(() => {
    setLayersOptions(project.layers.map(layer => ({
      value: layer.itId, // Suppose que chaque élément de project.layers a une propriété 'id'
      label: layer.itName // Et une propriété 'name', et tu mets ce nom dans un tableau
    })));
  }, [])
  useEffect(() => {
    setItemCopy({ ...item });
  }, [item]);
  const handleChange = (obj) => {
    if (obj.target) {
      const { name, value } = obj.target;
      const parts = name.split('.');
      let newObj
      if (parts.length == 1) {
        newObj = { ...itemCopy, [parts[0]]: value };
      } else {
        newObj = { ...itemCopy, [parts[0]]: { ...itemCopy[[parts[0]]], [parts[1]]: value } }
      };
      setItemCopy(prevItem => ({ ...prevItem, ...newObj }));
    } else {
      setItemCopy(prevItem => ({ ...prevItem, ...obj }));
    }
  };
  const submit = async () => {
    let response = null;
    if (!itemCopy.itId || itemCopy.itId == '') {
      response = await save_item(itemCopy);
    } else {
      response = await update_item(itemCopy);
    }
    setItemSelected(null);
  }
  return (
    <div id="TreesGroupFrom" className=''>
      <div className="mb-5">
        <HtmlElement.formGroup name="itFeatures.childrenCount" value={itemCopy.itFeatures?.childrenCount} label="Nombre de sujets" size="lg" onChange={handleChange} />
        <HtmlElement.formGroup
          value={itemCopy.itName || ''}
          name='itName'
          label='Nom :'
          onChange={handleChange}
          required={true}
          className='mb-3'
        />
        <HtmlElement.formGroup
          type='textarea'
          value={(itemCopy.meta && itemCopy.meta.description) || ''}
          name='meta.description'
          label='Description :'
          onChange={handleChange}
          required={true}
          className='mb-3'
          rows={6}
        />
        <HtmlElement.formGroup
          type='colorSelect'
          name="itFeatures.color"
          allowEmpty={false}
          value={(itemCopy.itFeatures && itemCopy.itFeatures.color) || ''}
          onChange={handleChange}
          label='Couleur :'
          className='mb-3'
        />

        <LayerSelector
          selectedId={itemCopy.itParentId}
          name='itParentId'
          onChange={handleChange}
          required={true}
          allowCreate={true}
        />
      </div>
      {userCan('editItem') &&
        <div>
          <HtmlElement.submit text="Sauvegarder" onClick={submit} />
        </div>
      }
      {debug(itemCopy)}
    </div>
  );
};
export default TreesGroupForm;
